export class AppConfigData {
  static get apiBaseUrl(): string {
    return (window as any).appConfig?.apiBaseUrl;
  }

  static get imageBaseUrl(): string {
    return (window as any).appConfig?.imageBaseUrl;
  }

  static get fhirServer() {
    return (window as any).appConfig?.fhirServer
  }

  static get aiBaseURL() {
    return (window as any).appConfig?.aiBaseURL;
  }

  static get openAI() {
    return (window as any).appConfig?.openAI;
  }

  static get CCDAValidate() {
    return (window as any).appConfig?.CCDAValidate;
  }

  static get ipUrl() {
    return (window as any).appConfig?.ipUrl;
  }
  static get cliNoteUrl() {
    return (window as any).appConfig?.clinoteBaseUrl;
  }
  static get openAISelfUrl() {
    return (window as any).appConfig?.openAISelf;
  }
  static get openAIstatusUrl() {
    return (window as any).appConfig?.openAIStatus;
  }

  static get eduBaseURL() {
    return (window as any).appConfig?.eduBaseURL;
  }

  static get signalRBaseURL() {
    return (window as any).appConfig?.signalRBaseURL;
  }

  static get scannerBaseUrl() {
    return (window as any).appConfig?.scannerBaseUrl;
  }

  static get autoSaveURL() {
    return (window as any).appConfig?.autoSaveURL;
  }
  static get isCerfication() {
    return (window as any).appConfig?.isCertification;
  }
}